import Vue from 'vue'
import Router from 'vue-router'
const HomeDesktop = () => import('@/components/index.vue')
const HomeMobile = () => import('@/components/mobileIndex.vue')
const Init = () => import('@/components/init.vue')
const Documentation = () => import('@/components/Shared/Documentation/documentation.vue')
const BotIndex = () => import('@/components/Bot/bot.template.vue')
const ProfileTemplate = () => import('@/components/Profile/profile.template.vue')
const SupportTemplate = () => import('@/components/Support/support.template.vue')
//const AuthFogetpaswword = () =>import('@/components/Shared/Auth/forget.password.component.vue')
const NewsLetterTemplate = () => import('@/components/NewsLetter/register.component.vue')

import UserRouter from './user.router.js'
import BotRouter from './bot.router.js'
import DocumentationRouter from './doc.router.js'
import SupportRouter from './support.router.js'

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
  if (!localStorage.token) {
    console.log('tets token in store', localStorage.token)
    next()
    return
  }
  next()
}

export default new Router({
  mode: 'history',
  hashbang: false,
  routes: [
    {
      path: '/',
      name: 'Root',
      component: Init
   },
    {
      path: '/Home',
      name: 'Home',
      component: HomeDesktop,
      meta:{
        title: 'Home - Application Msl Bot'
      },
      beforeEnter: ifAuthenticated
    },
    {
      path: '/Home',
      component: HomeDesktop,
      children: [
        {
          meta: {
            showModal: true
          },
          path: '/NewsLetter',
          component: NewsLetterTemplate,
          props: true
        }
      ]
    },
    // {
    //   path: '/NewsLetter',
    //   name: 'NewsLetter',
    //   component: NewsLetterTemplate,
    //   meta:{
    //     title: 'Home - News Letter'
    //   },
    //   beforeEnter: ifAuthenticated
    // },
    {
      path: '/HomeMobile',
      name: 'HomeMobile',
      component: HomeMobile,
      meta:{
        title: 'HomeMobile - Application Msl Bot'
      },
      beforeEnter: ifAuthenticated
    },
    {
      path: '/documentation',
      component: Documentation,
      meta:{
        title: 'Home - documentation'
      },
      children: DocumentationRouter,
      beforeEnter: ifAuthenticated
    },
   
    {
      path: '/user/setting',
      component: ProfileTemplate,
      meta:{
        title: 'Setting Account - Application Msl Bot'
      },
      children: UserRouter,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/application',
      component: BotIndex,
      meta:{
        title: 'List Bot - Application Msl Bot'
      },
      children: BotRouter,
      beforeEnter: ifAuthenticated
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js